const inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
export const DEFAULT_TIMEOUT = 7000; // (ms)
export const INSURANCE_REGISTER_TIMEOUT = 180000; // 3분(ms)
export const TEMP_DATA_EXPIRES = inFifteenMinutes;
export const TOKEN_TIMEOUT = 30; // 30분
export const TEMP_DATA_TIMEOUT = 3; // 3분
